import styles from "./style.module.css";
import { Navigate, useLocation } from 'react-router-dom';
import { getTokenItem, TOKEN_KEY } from '../../../utils/helpers';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = getTokenItem(TOKEN_KEY.AUTH_TOKEN);
  const location = useLocation();

  if (!token) {
    console.warn("[ProtectedRoute] No token → redirecting to /signIn");
    return (
      <Navigate 
        to="/signIn" 
        replace 
        state={{ from: location }} // store where user wanted to go
      />
    );
  }

  return children;
};